
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      showExpandableContent: false,
      accordionButtonState: 'collapsed'
    };
  },
  methods: {
    expandToggle: function expandToggle() {
      this.showExpandableContent = !this.showExpandableContent;
      this.accordionButtonState = this.showExpandableContent ? 'expanded' : 'collapsed';
      this.$refs.expandableContent.classList.toggle('expanded');
      this.$refs.expandableButton.classList.toggle('expanded');
      this.$refs.expandableContainer.classList.toggle('expanded');
    }
  }
};